// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import Swal from "sweetalert2";
import { createApiClient } from "./config/axios-config.js";
import { LoginConfig } from "./config/login-config.js";

class LoginService {

  #loginUrl = LoginConfig.indexPageURL.replace("/index", "/login");
  #apiClient = createApiClient();

  ssoLogin() {
    window.location.href = `${LoginConfig.apiBaseURL}/auth/login`;
  }

  ssoLogout() {
    window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${this.#loginUrl}`;
  }
  async fetchMockLogin() {
    return this.#apiClient({
      method: "GET",
      url: "/auth/mock_login_code"
    })
    .then(res => {
      const mockLogin = res.data.param_value1;
      return mockLogin;
    })
    .catch(error => {
      console.log(error);
    });
  }
  async mockLogin({ username }) {
    //使用 #apiClient 方法向後端發送 POST 請求，請求 URL 為 /auth/login，並傳遞使用者名稱及密碼
    return this.#apiClient({
      method: "POST",
      url: "/auth/login",
      data: {
        username: username,
        password: username
      }
    }).then(res => {
      const accessToken = res.data.access_token;
      window.localStorage.setItem("accessToken", accessToken);
      window.location.href = `${LoginConfig.indexPageURL}`;
      // MFAService.showMfaConfig();
    }).catch(error => {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Login Fail",
        html: "<h2>User does not exist in db</h2>"
      });
    });
  }

  sysLogout() {
    // SSO logout
    const token = window.localStorage.getItem("accessToken");
    this.#apiClient({
      method: "POST",
      url: "/auth/logout",
      params: {
        site: 6
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(() => {
      window.localStorage.removeItem("accessToken");
      window.location.href = this.#loginUrl;
    });
    // window.location.replace(`https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${login_url}`);
  }
}

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export default new LoginService();